import React from 'react';

import {Flex} from "antd";
import IntlMessage from "../../../../components/IntlMessage/IntlMessage";
import MyText from "../../../../components/UI/Text/MyText";
import {useDispatch, useSelector} from "react-redux";
import {getUserByToken} from "../../../../store/slices/userSlice";
import DirectorContractList from "./Contracts/DirectorContractList";

const DirectorContractsPage = () => {
    const dispatch = useDispatch();
    const {user} = useSelector(state => state.user)
    if (user === null) {
        dispatch(getUserByToken());
    }
    return (
        <Flex style={{width: "100%"}} gap={20} align={"flex-start"} justify={"flex-start"} vertical>
            <MyText size={"large"} uppercase strong><IntlMessage id={'contracts'}/></MyText>
            {/* RectorContractList отличался от DirectorContractList только именем компонента —
                держать две копии после объединения ролей незачем. */}
            <DirectorContractList/>
        </Flex>
    );
};

export default DirectorContractsPage;